<template>
	<div>
		<transition name='fade'>
			<div id='side_menu' v-if='open'>
				<b-nav vertical class="w-100">
					<b-nav-item href="#home"
					v-on:click="selectedLink('open')">
						<i class="material-icons">
						menu
						</i>
					</b-nav-item>
					<template v-for="item in items"
					>
						<b-nav-item v-if="item.name !== '#contact'" class='text-uppercase'
						:key="item.name"
					:active='item.active'
					:href="item.name"
					v-on:click="selectedLink(item.name)">

					<span class='d-flex justify-content-start align-items-center'>
						<i class="material-icons mr-2">{{item.icon}}</i>
						<span>{{item.title}}</span>
					</span>
					<hr>
					</b-nav-item>
					</template>
				</b-nav>			

				<div id="side_menu_contact">
					<div class="set_bottom">
						<b-img alt="HME Rotary | The UK's longest established Rotary engine specialists" fluid src="../assets/hme-logo--web.png"/>
					<Contact :center='false'/>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>
<script>
	import Contact from './Contact.vue'
export default {
	name: 'Menu',
	components: {
		Contact
	},
	props: {
		// nav items as objects
		open:Boolean,
		items: Object,
	},
	methods:{
		selectedLink(open){
			this.$emit('nav',open)
		}
	}
}
</script>